import { IGetMetaParams, IMetaDTO } from "./../../../types/meta.d";
import { useCallback, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Loja } from "../../../services/Lojas";
import { toast } from "react-toastify";
import { ISelectOptions } from "../../../types/inputs";
import { useContextSite } from "../../../context/Context";
import { Meta } from "../../../services/Meta";
import { IPagination } from "../../../types/pagination";
import { MESES_OPTIONS } from "../../../enums/meses";
import { useNavigate } from "react-router-dom";

const ANOS_NUM: number[] = Array.from({ length: 21 }, (_, i) => 2020 + i);

const ANOS_OPTIONS = ANOS_NUM.map((ano) => ({
  label: String(ano),
  value: ano,
}));

export const useGoals = () => {
  const isMobile = useMediaQuery({ maxWidth: "640px" });
  const [metas, setMetas] = useState<IMetaDTO[]>([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [lojasOptions, setLojasOptions] = useState<ISelectOptions[]>([]);
  const { setIsLoad } = useContextSite();
  const [filter, setFilter] = useState<IGetMetaParams>({});
  const [pagination, setPagination] = useState<IPagination>({} as IPagination);
  const [numberPage, setNumberPage] = useState(0);
  const navigate = useNavigate();

  const getLojas = useCallback(() => {
    Loja.get()
      .then(({ data }) => {
        const options = data.content.map((loja) => ({
          label: loja?.nome,
          value: loja?.endereco?.uuidMunicipio,
        }));
        setLojasOptions(options);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      );
  }, []);

  function getMetas(props?: IGetMetaParams) {
    setIsLoad(true);

    Meta.get({ ...props, size: 5 })
      .then(({ data }) => {
        setMetas(data.content);
        setPagination({
          actualPage: data.number,
          totalPage: data.totalPages,
          totalRegister: data.totalElements,
        });
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  function updateFilter(props: Partial<IGetMetaParams>) {
    setFilter((prev) => ({ ...prev, ...props }));
  }

  function handleFilter(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    getMetas({ ...filter, page: 0 });
    setNumberPage(0);
  }

  useEffect(() => {
    if (!openFilter) {
      setFilter({});
      getMetas();
    }
  }, [openFilter]);

  useEffect(() => {
    getMetas({ ...filter, page: numberPage });
  }, [numberPage]);

  useEffect(() => {
    getLojas();
  }, []);

  return {
    isMobile,
    metas,
    openFilter,
    setOpenFilter,
    ANOS_OPTIONS,
    lojasOptions,
    filter,
    updateFilter,
    pagination,
    setNumberPage,
    handleFilter,
    navigate,
    MESES_OPTIONS,
  };
};
